import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  chatBody: {
    height: '400px',
    border: '1px solid #dee6ea',
    borderRadius: '10px',
    background: '#fff',
    position: 'relative',
    '& .message-container': {
      width: '100%',
      height: '100%',
      overflowX: 'hidden'
    }
  },
  message: {
    background: '#ececec',
    margin: '10px 3px',
    borderRadius: '10px',
    padding: '10px'
  },
  chatFooter: {
    width: '90%',
    margin: '10px 0',
    border: '1px solid #c9c6c6',
    padding: '15px',
    borderRadius: '10px'
  },
  sendBtn: {
    width: '10%',
    padding: '9px',
    position: 'relative',
    top: '5px',
    background: '#fff',
    borderRadius: '10px',
    border: '1px solid #c9c6c6'
  },
  messageContent: {
    fontSize: '15px',
    fontWeight: 500
  },
  messageMeta: {
    fontSize: '10px'
  },
  iconButton: {
    float: 'right',
    marginRight: theme.spacing(0.5)
  },
  buttonMargin: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1)
  }
}));

export default useStyles;
